<template>
  <div class="page-content">
    <page-template
      ref="plusSettingTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="addColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from "@/components/template/pageTemplate";
  import api from "@/config/api";
  import userPower from '@/mixin/userPower'

  export default {
    mixins: [userPower],
    components: {
      pageTemplate,
    },
    data() {
      return {
        isCheck:false,
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: "产品名称",
              prop: "name",
              type: "input",
              isFuzzy: true,
              placeholder: "请输入产品名称",
              span: 12,
            },
            {
              label: "产品编码",
              prop: "code",
              type: "input",
              isFuzzy: true,
              placeholder: "请输入产品编码",
              span: 12,
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              span: 12,
              multiple: true,
              data: [],
              url: api.store.store,
              change:this.check
            },
          ],
        },
        // 更多功能
        toolConfig: [
          {
            label: "新增",
            code: "insert",
          },
          {
            label: "同步",
            code: "sync",
            callback: this.sync,
          },
          {
            label: "编辑",
            type: this.$utils.buttonType.tableOperate,
            code: "update",
          },
          {
            label: "删除",
            code: "delete",
            type: this.$utils.buttonType.tableOperate,
          },
        ],
        // 表格信息配置
        tableOptions: {
          showSelect: true,
          indexShow: true,//是否显示索引
          columns: [
            {label: "产品名称", prop: "name", width: "120", align: "center"},
            {label: "产品编码", prop: "code", width: "120", align: "center"},
            {
              label: "类型",
              prop: "type",
              width: "120",
              align: "center",
              enumData: this.$utils.getCacheStatus("mbPlusProduct.type"),
            },
            {
              label: "优惠方式",
              prop: "discountType",
              width: "120",
              align: "center",
              enumData: this.$utils.getCacheStatus("mbMemberCategory.discountType"),
            },
            {
              label: "产品金额",
              prop: "productMoney",
              width: "120",
              align: "center",
            },
            {
              label: "开始时间",
              prop: "startDttm",
              width: "135",
              align: "center",
            },
            {
              label: "结束时间",
              prop: "endDttm",
              width: "135",
              align: "center",
            },
            {
              label: "状态",
              prop: "status",
              width: "100",
              align: "center",
              enumData: this.$utils.getCacheStatus("mbPlusProduct.status"),
            },
            {
              label: "备注",
              prop: "remarks",
              width: "120",
              align: "center",
            },
          ],
          url: api.member.plusSetting,
        },
        // 添加字段
        addColumns: {
          labelWidth: "160px",
          span: 12,
          columns: [
            {
              label: "产品名称",
              type: "input",
              prop: "name",
              rule: [
                {
                  required: true,
                  message: "请输入plus产品名称",
                  trigger: "blur",
                },
              ],
            },
            {
              label: "产品编码",
              type: "code",
              prop: "code",
              isButtonShow: false,
              checkUrl: api.member.plusSetting + "/check/code",
              rule: [
                {required: true, message: "请输入产品编码", trigger: "blur"},
              ],
            },
            {
              label: "类型",
              type: "select",
              prop: "type",
              data: this.$utils.getCacheStatus("mbPlusProduct.type"),
              span: 24,
               rule: [
                {required: true, message: "请输入类型", trigger: "blur"},
              ],
            },
            {
              label: "优惠方式",
              type: "select",
              prop: "discountType",
              data: this.$utils.getCacheStatus("mbMemberCategory.discountType"),
              change: this.hide,
              rule: [
                {required: true, message: "请选择优惠方式", trigger: "blur"},
              ],
            },
            {
              label: "折扣率(0~1)",
              type: "inputNumber",
              prop: "discountRate",
              max: 1,
              min: 0.0001,
              hidden: true,
              rule: [
                {required: true, message: "请输入折扣率", trigger: "blur"},
              ],
            },
            {
              label: "产品金额",
              type: "inputNumber",
              prop: "productMoney",
              rule: [
                {required: true, message: "请输入产品金额", trigger: "blur"},
              ],
              span: 24,
            },
            {
              label: "开始时间",
              type: "dateTimePicker",
              prop: "startDttm",
              rule: [
                {
                  required: true,
                  message: "请选择活动开始时间",
                  trigger: "blur",
                },
              ],
            },
            {
              label: "结束时间",
              type: "dateTimePicker",
              prop: "endDttm",
              rule: [
                {
                  required: true,
                  message: "请选择活动结束时间",
                  trigger: "blur",
                },
              ],
            },
            {
              label: "备注",
              type: "textarea",
              prop: "remarks",
              span: 22,
            },
          ], // 表单label
          url: api.member.plusSetting,
        },
      };
    },
    created() {
      this.setStore(this.searchOptions.simple);
    },
    methods: {
      check(data){
        if(data.storeId.length != 0){
          this.isCheck = true
        }
        else{
          this.isCheck = false
        }
      },
      sync() {
        if(this.isCheck != true){
          this.$confirm("请选择门店名称！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
        }

        // 门店集合
        let ids = this.$refs.plusSettingTemplate.getSimpleParams().storeId;
        if (!ids) {
          this.$message({message: "请选择门店后进行同步", type: "warning"});
          return;
        }
        // 需要同步的数据
        let tableRows = this.$refs.plusSettingTemplate.getTableSelectRow();
        if (tableRows.length === 0) {
          this.$confirm("请选择需要同步的信息！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
          return;
        }
        this.$axios
          .fetchPost(api.member.plusSetting + "/sync", {
            plusProductList: tableRows, ids: ids
          })
          .then((data) => {
            if (data.code === 200 && data.data) {
              this.$notify({
                type: "success",
                title: '同步操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: "同步成功", type: "success"});
            } else {
              this.$message({message: data.msg, type: "error"});
            }
          })
          .catch((err) => {
            this.$message({message: "请求失败！", type: "error"});
          });
      },
      hide(form) {
        if (form.discountType == "10" || form.discountType == "30") {
          this.addColumns.columns[4].hidden = true;
        } else {
          this.addColumns.columns[4].hidden = false;
          this.addColumns.columns[4].rule[0].required = true;
        }
      },
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/member/Plush/PlusSetting.vue